import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { 
  NumberFormatValues, 
  NumericFormat, 
  SourceInfo 
} from "react-number-format";

const Container = styled(FormControl)(() => ({
  maxWidth: '100%',
  minWidth: '33%'
}));

type CompanyProfileNumEmployeesInputProps = {
  className?: string;
  numEmployees?: string | number;
  onChange: (numEmployees: string) => void;
};

export default function CompanyProfileNumEmployeesInput(props: Readonly<CompanyProfileNumEmployeesInputProps>) {
  const { className, onChange } = props;

  function hasInvalidNumEmployees(): boolean {
    return Boolean(
      props.numEmployees 
      && props.numEmployees.toString().length > 0 
      && (
        Number.isNaN(Number(props.numEmployees)) 
        || Number(props.numEmployees) < 0
      )
    );
  }

  return (
    <Container className={className}>
      <NumericFormat
        id="numEmployees"
        variant="outlined"
        customInput={TextField}
        label="Number of Employees"
        value={props.numEmployees ?? ""}
        type='text'
        thousandSeparator
        error={hasInvalidNumEmployees()}
        helperText={hasInvalidNumEmployees() ? "Invalid number of employees" : ""}
        onValueChange={(values: NumberFormatValues, _sourceInfo: SourceInfo) => {
          onChange(values.value);
        }}
      />
    </Container>
  );
}
